@use 'themes/westfield' as *;
// This file is duplicated from website_client.
// It does not use units by better to leave it untouched.
// Universal Login may eventually be moved to the monorepo,
// in which case this could be deleted.

@use '../../../scentregroup-ui/tools/dirg' as *;
@use '../../../scentregroup-ui/tools/dirg-breakpoint' as *;
@use '../../../scentregroup-ui/tools/color' as *;
@use '../../../scentregroup-ui/tools/typography.module' as *;

.task-header {
  --margin-x: 24px;
  --max-width: 1152px;

  @extend .bodyFont;
  background-color: #fff6ed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 96px;

  > .wrapper {
    flex: 1;
    max-width: var(--max-width);
    padding-inline: units(1.25);
    display: flex;
    justify-content: center;
    align-items: center;

    @include fromBreakpoint(tablet) {
      padding-inline: 40px;
    }

    > .header {
      flex: 1;
      display: flex;

      .backSection {
        display: flex;
        min-width: 48px;
        justify-content: center;
        align-items: center;
        gap: units(0.5);
        color: initial;
        text-decoration: none;
        cursor: pointer;
        outline: none;
        font: inherit;
        line-height: units(1);
        white-space: nowrap;
      }

      .backSection .icon {
        width: 24px;
        height: 24px;
      }
    }

    > .logoSection {
      text-align: center;
      flex-grow: 0;
    }

    .logo {
      color: #1c1f24;
      height: units(2.25);
      transform: scale(1.5);
    }

    .logoLink {
      display: inline-block;
    }
  }
}

.mainLogo {
  width: units(6);
  height: units(2);
}

// mobile
@media screen and (max-width: 927.9px) {
  .desktop {
    display: none;
  }
}

// desktop
@media screen and (min-width: 928px) {
  .mobile {
    display: none;
  }

  .task-header {
    --margin-x: 48px;
  }

  .logoSection {
    &.membershipLogoSection {
      padding-bottom: units(1);
    }
  }
}
